var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiFilledShowHide124(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#141414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.567 15.155l-.008-.007 5.59-5.59.008.008L17.82 6.9h-.01l3.044-3.043a.5.5 0 00-.707-.708l-3.23 3.231A10.338 10.338 0 0012 5C6.782 5 2.424 9.9 1.213 11.4a.937.937 0 000 1.189A21.824 21.824 0 006.2 17.1l-3.054 3.046a.5.5 0 00.707.708l3.228-3.229.01.006zM8 12a3.982 3.982 0 012-3.445V12l3.64-3.64a3.854 3.854 0 01.8.492L8.853 14.44A3.927 3.927 0 018 12zm14.787.6C21.576 14.1 17.218 19 12 19a9.747 9.747 0 01-3.865-.858l2.421-2.421a3.977 3.977 0 005.164-5.163l3.025-3.026a22.477 22.477 0 014.043 3.874.937.937 0 01-.001 1.194z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiFilledShowHide124);
export default __webpack_public_path__ + "static/media/ui-filled-show-hide-1-24.0bcd9004.svg";
export { ForwardRef as ReactComponent };